export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";